import { render, staticRenderFns } from "./Pdf.vue?vue&type=template&id=0b365ed4&scoped=true"
import script from "./Pdf.vue?vue&type=script&lang=js"
export * from "./Pdf.vue?vue&type=script&lang=js"
import style0 from "./Pdf.vue?vue&type=style&index=0&id=0b365ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b365ed4",
  null
  
)

export default component.exports